export default __webpack_public_path__ + "static/media/JKSM.d46db1b8.png";